import React, { PropsWithChildren } from "react";
import { ViewStyle, StyleSheet, TouchableOpacity } from "react-native";
import ReactNativeModal from "react-native-modal";
import Toast from "component/toast";
import Button from "component/button/Button";
import ModalBar from "component/modal/ModalBar";

import { sizes, colors } from "asset/constant";

type ModalT = {
  visible?: boolean;
  close?: () => void;
  hideToast?: boolean;
  contentContainerStyle?: ViewStyle;
  disableCloseWithOutsideTap?: boolean;
  disableCloseWithBakButtonTap?: boolean;
};

const ModalInfinityList: React.FC<PropsWithChildren<ModalT>> = ({
  close,
  visible,
  children,
  hideToast,
  disableCloseWithOutsideTap,
  disableCloseWithBakButtonTap,
}) => {
  return (
    <ReactNativeModal
      isVisible={visible}
      style={{ margin: 0 }}
      animationIn={"slideInUp"}
      animationOut={"slideOutDown"}
      onBackButtonPress={!disableCloseWithBakButtonTap ? close : null}
    >
      <TouchableOpacity
        activeOpacity={1}
        style={styles.container}
        onPress={!disableCloseWithOutsideTap ? close : null}
      >
        <TouchableOpacity activeOpacity={1} style={styles.box}>
          <ModalBar />
          <Button
            onPress={close}
            square={45}
            bgColor="transparent"
            absolute={{ left: 5, top: 5, zIndex: 2 }}
            icon={{ type: "feather", name: "x", color: colors.theme }}
          />
          {children}
        </TouchableOpacity>
      </TouchableOpacity>
      {!hideToast && <Toast.Provider />}
    </ReactNativeModal>
  );
};

export default React.memo(ModalInfinityList);

const styles = StyleSheet.create({
  container: { width: "100%", height: "100%", justifyContent: "center" },

  box: {
    width: "90%",
    maxWidth: 640,
    maxHeight: "90%",
    overflow: "hidden",
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: sizes.radius.lg,
  },
});
